import { render, staticRenderFns } from "./medico.vue?vue&type=template&id=b2012ff8&"
import script from "./medico.vue?vue&type=script&lang=js&"
export * from "./medico.vue?vue&type=script&lang=js&"
import style0 from "./medico.vue?vue&type=style&index=0&id=b2012ff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports